import '@styles/pages/bigteam.scss';

import { TwigFormValidator } from '@tools/twig-form/validator';
import { showSubmitLoader } from '@atoms/spinner';
import { addCaptchaToForm } from '@elements/recaptcha-helper';
import { initVuePhoneInput } from '@atoms/twig-phone-input';
import { stickyCta } from '@organisms/sticky-cta';

const phoneInputApp = initVuePhoneInput('vue-phone-input');

const formSelector = 'form_bigteam';

const validator = new TwigFormValidator({
  formSelector: `#${formSelector}`,
  rules: {
    'huge_deal_contact[fullName]': [ 'required', 'noNumbers' ],
    'huge_deal_contact[email]': [ 'required', 'email' ],
    'huge_deal_contact[body]': 'required',
    'huge_deal_contact[phoneNumber]': 'phone',
  },
  messages: {
    'huge_deal_contact[fullName]': [ 'required', 'noNumbers' ],
    'huge_deal_contact[email]': [ 'required', 'email' ],
  },
  onFailure: (event, messages) => {
    const phoneError = messages['huge_deal_contact[phoneNumber]'];
    phoneInputApp.error = phoneError ?? null;
    document.querySelector('form .error').scrollIntoView(
      { behavior: 'instant', block: 'center' },
    );
    event.stopImmediatePropagation();
  },
  onSuccess: (event) => {
    phoneInputApp.error = null;
    showSubmitLoader(event.target.querySelector('button[type="submit"]'));
  },
});

validator.init();

document.querySelectorAll('.btn-gotoform').forEach((item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    if (!document.body.classList.contains('is-mobile')) {
      window.scrollTo(0, 0);
      return;
    }

    const banner = document.querySelector('#banner');
    const header = document.querySelector('#header');
    const bannerHeight = banner ? banner.getBoundingClientRect().height : 0;
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const formPos = document.querySelector('.bigteam-form').getBoundingClientRect().top;

    window.scrollBy(0, formPos - bannerHeight - headerHeight);
  });
});

// Here we display or not the cta to contact match experts, depending if the contact form is on the screen.
if (window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet) {
  stickyCta('.bigteam-fixed-anchor', '#form_bigteam', 'bigteam-fixed-anchor');
}

window.addEventListener('load', () => {
  addCaptchaToForm(formSelector, 'huge_deal_contact');
});
